import React from 'react';

/** Single place to point every CTA at the live checkout action. */
export const CHECKOUT_URL = '#get-access';
interface CTAButtonProps {
  label: string;
  href?: string;
  external?: boolean;
  className?: string;
}
export function CTAButton({
  label,
  href = '#get-access',
  external = false,
  className = ''
}: CTAButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-[14px] bg-spark px-6 py-4 text-center text-base font-extrabold tracking-tight text-white shadow-lg shadow-spark/30 hover:bg-spark-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-spark sm:text-[17px] ${className}`} data-id="element-64" data-mp="2g1o8al0szad7">
      {label}
    </a>;
}